import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'ed-search'
})
export default class EdSearch extends Vue {

}